import { AxiosResponse } from 'axios';
import { saveState } from '../utils/saveUserState';
import apiClient from '../../../services/apiClient';
import uuid from '../../../services/uuid';

export const getRedirectURLLogin = (redirectUrl?: string, loginHint?: string) => {
  const payload = {
    host: window.location.host,
    state: uuid.generate(),
    ...(loginHint && loginHint.trim() && { login_hint: loginHint }),
  };
  saveState(redirectUrl || '', payload.state);
  return apiClient.post<string>('/v1/sign-in', payload).then(({ data }: AxiosResponse<string>) => {
    return data;
  });
};
